import { useI18n } from './useI18nFormatters.tsx';
import { useEffectEvent } from './useEffectEvent.ts';
import { useCapabilityValue } from '../store/devices/useCapabilityValue.ts';

export const SYSTEM_CAPABILITIES = ['onoff', 'speaker_playing', 'button'];

export function useQuickAction({ device }) {
  const { i18n } = useI18n();

  const quickActionId = device?.ui?.quickAction ?? null;
  const baseId = quickActionId?.split('.')[0];

  const [value, setValue, capabilityObj] = useCapabilityValue({
    deviceId: device?.id,
    capabilityId: quickActionId,
  });

  let quickActionTitle = i18n.messageFormatter(`device.quickAction.default`);

  if (baseId != null && SYSTEM_CAPABILITIES.includes(baseId)) {
    if (capabilityObj?.getable === true) {
      quickActionTitle = i18n.messageFormatter(`device.quickAction.${baseId}.${value ?? false}`);
    } else if (capabilityObj != null) {
      quickActionTitle = i18n.messageFormatter(`device.quickAction.${baseId}`);
    }
  }

  const onQuickAction = useEffectEvent(() => {
    if (capabilityObj == null) {
      return;
    }

    if (capabilityObj.setable === true && capabilityObj.getable === true) {
      const nextValue = !value;

      setValue(nextValue)
        .then((result) => {})
        .catch((error) => {});
    } else if (capabilityObj.setable === true) {
      setValue(true)
        .then((result) => {})
        .catch((error) => {});
    }
  });

  return { value, onQuickAction, quickActionId, quickActionTitle };
}
